/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignAgentsRequest
 */
export interface AssignAgentsRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof AssignAgentsRequest
     */
    cmGroupIds?: Array<number>;
}

/**
 * Check if a given object implements the AssignAgentsRequest interface.
 */
export function instanceOfAssignAgentsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AssignAgentsRequestFromJSON(json: any): AssignAgentsRequest {
    return AssignAgentsRequestFromJSONTyped(json, false);
}

export function AssignAgentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignAgentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cmGroupIds': !exists(json, 'cmGroupIds') ? undefined : json['cmGroupIds'],
    };
}

export function AssignAgentsRequestToJSON(value?: AssignAgentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cmGroupIds': value.cmGroupIds,
    };
}

